import * as React from 'react';
import { Dispatch, Action, compose } from 'redux';
import { connect } from 'react-redux';
import { IAppState, systemStateMessageOperations } from '../redux/modules';
import { Snackbar, IconButton, SnackbarContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { SystemStateMessageState } from '../redux/modules/systemStateMessage';
import { SystemStateMessageTypes } from '../models/SystemStateMessageTypes';
import ErrorIcon from '@material-ui/icons/Error';

interface OwnProps {
  systemStateMessage : SystemStateMessageState;
  resetMessage: () => any;
}
interface OwnState {
  isOpen: boolean;
}

class SystemStateMessageView extends React.Component<OwnProps, OwnState> {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false
    };
    this.handleClose = this.handleClose.bind(this);
  }
  componentWillReceiveProps(newProps) {
    this.setState({ isOpen: (newProps.systemStateMessage.message.message || '') !== '' });
  }
  handleClose(event, reason){
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ isOpen: false });
    this.props.resetMessage();
  }
  chooseIcon(type: SystemStateMessageTypes) {
    const iconStyle = {
      opacity: 0.9,
      marginRight: '8px',
      fontSize: '20px'
    };
    switch(type) {
      case SystemStateMessageTypes.ERRROR:
        return (<ErrorIcon style={iconStyle}/>);
      case SystemStateMessageTypes.INFO:
        return (<InfoIcon style={iconStyle}/>);
      case SystemStateMessageTypes.SUCCESS:
        return (<CheckCircleIcon style={iconStyle}/>);
    }
    return null;
  }
  chooseContentStyle(type: SystemStateMessageTypes) {
    switch(type) {
      case SystemStateMessageTypes.ERRROR:
        return { backgroundColor: '#d32f2f' };
      case SystemStateMessageTypes.INFO:
        return { backgroundColor: '#1976d2' };
      case SystemStateMessageTypes.SUCCESS:
        return { backgroundColor: '#43a047' };
    }
    return {};
  }

  render() {
    let autoHideDuration;
    // エラーのときは自動で閉じない
    if (this.props.systemStateMessage.message.type !== SystemStateMessageTypes.ERRROR) {
      autoHideDuration = 6000;
    }
    const icon = this.chooseIcon(this.props.systemStateMessage.message.type);
    const contentStyle = this.chooseContentStyle(this.props.systemStateMessage.message.type);

    return(
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={this.state.isOpen}
        autoHideDuration={autoHideDuration}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message',
        }}
      >
        <SnackbarContent
          style={contentStyle}
          message={
            <span id="message" style={{ display: 'flex' }}>
              {icon}
              {this.props.systemStateMessage.message.message}
            </span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              // className={classes.close}
              onClick={() => this.handleClose(null, null)}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => {
  return {
    resetMessage: () => {
      systemStateMessageOperations.reset()(dispatch);
    }
  };
};

const mapStateToProps = (appState: IAppState) => {
  return {
    systemStateMessage: appState.systemStateMessage
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SystemStateMessageView);



// WEBPACK FOOTER //
// ./src/components/SystemStateMessageView.tsx